// extracted by mini-css-extract-plugin
export default {"wrapper":"phone-input_wrapper_FhlYs","select":"phone-input_select_Cd2bi","input":"phone-input_input_A185h"};